module.exports = __webpack_public_path__ + "static/media/Art_Gallery.7b497247.md";